import React from 'react'
import EstiamPage from '../parts/pages/EstiamPage'

export default function Estiam() {
  return <EstiamPage />
}
